import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const BOOK_IMG =
  "https://customer-assets.emergentagent.com/job_real-estate-varna/artifacts/vjouw2f4_Screenshot%202026-07-15%20at%2012.03.38.png";

export default function Book() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section
      id="book"
      data-testid="book-section"
      className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 sm:py-32 lg:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 sunset-glow pointer-events-none" />
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-8 lg:gap-16 items-center"
        >
          {/* Book */}
          <motion.div
            initial={{ opacity: 0, y: 60, rotate: -3 }}
            whileInView={{ opacity: 1, y: 0, rotate: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.1, ease: [0.2, 0.8, 0.2, 1] }}
            className="col-span-12 md:col-span-5 lg:col-span-4 lg:col-start-2"
          >
            <div className="relative mx-auto max-w-[380px]">
              <div className="absolute -inset-8 bg-[radial-gradient(ellipse_at_center,rgba(234,127,39,0.25),transparent_65%)] blur-2xl" />
              <img
                src={BOOK_IMG}
                alt="Играта на Имотите — книга от Иво Димовски"
                className="relative w-full h-auto drop-shadow-[0_30px_60px_rgba(234,127,39,0.25)]"
                data-testid="book-cover-img"
              />
            </div>
          </motion.div>

          {/* Copy */}
          <div className="col-span-12 md:col-span-7 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#F5892E]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
                Автор — Иво Димовски
              </span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mb-8">
              От създателя на книгата{" "}
              <span className="text-[#F5892E]">„Играта на Имотите&rdquo;.</span>
            </h2>
            <p className="text-lg sm:text-xl text-[#F5EBD9]/75 leading-relaxed max-w-[58ch] mb-10">
              Събитието се организира от Иво Димовски — автор на бестселъра „Играта на
              Имотите&rdquo;. Едни и същи принципи. Едни и същи стратегии. Едни и същи хора,
              които реално правят пари от имоти. На живо, във Варна.
            </p>

            <div className="grid grid-cols-3 gap-6 mb-10 max-w-md">
              <div>
                <div className="font-display text-3xl sm:text-4xl text-[#F5892E]">10K+</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#F5EBD9]/60 mt-1">
                  Читатели
                </div>
              </div>
              <div>
                <div className="font-display text-3xl sm:text-4xl text-[#F5892E]">500+</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#F5EBD9]/60 mt-1">
                  Участници 2025
                </div>
              </div>
              <div>
                <div className="font-display text-3xl sm:text-4xl text-[#F5892E]">13</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#F5EBD9]/60 mt-1">
                  Сесии
                </div>
              </div>
            </div>

            <button
              data-testid="book-cta-tickets"
              onClick={() => scrollTo("notify")}
              className="btn-accent px-8 py-4 rounded-full text-sm sm:text-base font-medium tracking-wide inline-flex items-center gap-3 uppercase"
            >
              Запиши имейла си — 25.10
              <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
